import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "relationship",
})
export class RelationshipPipe implements PipeTransform {
  relationship = "";

  transform(value: any): any {
    switch (value) {
      case "Cónyuge – Compañera": {
        this.relationship = "Cónyuge – Compañero(a)";
        break;
      }

      case "Hijo": {
        this.relationship = "Hijo(a)";
        break;
      }

      case "Madre": {
        this.relationship = "Madre";
        break;
      }

      case "Padre": {
        this.relationship = "Padre";
        break;
      }

      case "Hijastro": {
        this.relationship = "Hijastro(a)";
        break;
      }

      case "Hermano": {
        this.relationship = "Hermano(a)";
        break;
      }
    }

    return this.relationship;
  }
}
